// eslint-disable-next-line no-undef
export const baseEndpoint = process.env.REACT_APP_API_URL;
// eslint-enable-next-line no-undef
